import React from "react";
import ProjectCard from "./ProjectCard";
import RatePerfectDetails from "./RatePerfectDetails";
import ProGigDetails from "./ProGigDetails";

const projects = [
  {
    id: "progig-platform",
    className: "t-pg",
    kicker: "SaaS · in progress",
    title: "ProGig Platform",
    description:
      "Multi-tenant SaaS for DJs, Venues & Event Companies. Next.js 15, NestJS 11, AI (Gemini + Claude), pgvector, Stripe",
    visual: "dashboard",
    chips: ["Next.js", "NestJS", "PostgreSQL", "pgvector", "Turborepo"],
    link: "dialog",
    detailContent: <ProGigDetails />,
  },
  {
    id: "admin-dj-app",
    className: "t-dj",
    kicker: "Live · daily use",
    title: "DJ RISE Platform",
    description:
      "The booking site and private admin that run my DJ business every day. Leads, quote engine, events, payments, client portal, song requests, Gmail and Drive automation. Also powers RISEMN.",
    visual: "wave",
    chips: ["React", "MUI", "Express", "MongoDB", "Cloudflare"],
    link: "https://www.djrise.party/",
    linkLabel: "djrise.party",
  },
  {
    id: "rate-perfect",
    className: "t-rp",
    kicker: "Fintech · 2025-26",
    title: "Rate Perfect Platform",
    description: "Full-stack mortgage and finance platform. NestJS, Next.js, AWS, OpenAPI, PostgreSQL.",
    visual: "spec",
    chips: ["NestJS", "AWS CDK", "OpenAPI"],
    link: "dialog",
    detailContent: <RatePerfectDetails />,
  },
  {
    id: "reacirc-app",
    className: "t-vid",
    kicker: "Video",
    title: "REACirc App",
    link: "https://vimeo.com/1026656507/0eb484de83?share=copy",
  },
  {
    id: "agent-dashboard",
    className: "t-ag",
    kicker: "Video",
    title: "Agents Dashboard",
    description: "Dashboard to collect, analyze and display agent data, with interactive charts built from scratch.",
    link: "https://www.youtube.com/watch?v=8iqvGfCUnsI&ab_channel=AndrewKukhar/",
  },
];

const ProjectsSection = () => (
  <section className="sec" id="projects">
    <div className="sech">
      <h2>Featured projects</h2>
      <span className="mono">05 / selected</span>
    </div>
    <div className="bento">
      {projects?.map((project) => (
        <ProjectCard key={project?.id} {...project} />
      ))}
    </div>
  </section>
);

export default ProjectsSection;
